/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { WAITING_LIST_STATUS } from "../constants/constants";

const configs = {
  [WAITING_LIST_STATUS.SLOT_AVAILABLE]: {
    tone: "accentFilled",
    label: "Slot Available",
    cta: "Book Now",
    isPast: false,
    isSlotAvailable: true,
  },
  [WAITING_LIST_STATUS.WAITING]: {
    tone: "neutral",
    label: "Waiting",
    cta: null,
    isPast: false,
  },
  [WAITING_LIST_STATUS.CANCELLED]: {
    tone: "error",
    label: "Cancelled",
    cta: "Book it again",
    isPast: true,
  },
  [WAITING_LIST_STATUS.BOOKED]: {
    tone: "success",
    label: "Booked",
    cta: null,
    isPast: true,
  },
};

// "Slot available" is a widget-only state: the server reports the entry as still waiting and
// separately says the day now has room. is_available is null unless the request asked for it.
const getWaitingListState = (entry) =>
  entry.status === WAITING_LIST_STATUS.WAITING && entry.is_available === true
    ? WAITING_LIST_STATUS.SLOT_AVAILABLE
    : entry.status;

const getWaitingListStatusConfig = (entry) => (entry ? configs[getWaitingListState(entry)] || null : null);

export default getWaitingListStatusConfig;
